import InlineTeamSelect from './InlineTeamSelect';

export default InlineTeamSelect;
